<template>
    <div style="height: 300px; margin-bottom: 150px" v-show="loading || showChart ">
        <h3 class="text-muted mb-4">{{title}}</h3>
        <canvas v-show="!loading" :id=name ></canvas>
        <el-container v-loading="loading" class="ml-auto mr-auto"></el-container>
    </div>
</template>

<script>
    import Axios from '../utils/http/Axios'
    import Chart from 'chart.js'

    export default {
        name: "BurndownChart",
        props: {
            type: {
                type: String,
                required: true,
                validator: (value) => {
                    return ['developer', 'project', 'equipo'].includes(value)
                }
            },
            name: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: false,
                default: ""
            },
            width: {
                type: Number | String,
                required: false,
                default: 25,
                validator: (value) => {
                    return ["25", "50", "75", "100"].indexOf(value.toString()) !== -1
                }
            },
            legends: {
                type: Boolean,
                required: false,
                default: false

            },
            color: {
                type: String,
                required: false,
                default: "#2c82de"
            }
        },
        data() {
            return {
                showChart: false,
                loading: false
            }
        },
        mounted() {
            this.loading = true
            this.showBurnDown(this.name, this.type).finally(() => {
                this.loading = false;
            })
        },
        methods: {
            getIdealData(data) {
                let ideal_pp_per_day = data.total_release_pp / data.total_release_days;
                let ideal_data = [];
                for (let i = 0; i <= data.total_release_days; i++) {
                    ideal_data.push(Math.round(data.total_release_pp - (ideal_pp_per_day * i)));
                }
                return ideal_data;
            },
            getRealData(data) {
                let real_data = [];
                let finished_data = [];
                if (data.pps_by_day !== undefined) {
                    finished_data = Object.values(data.pps_by_day);
                }
                real_data.push(data.total_release_pp);
                for (let i = 0; i < finished_data.length; i++) {
                    real_data.push(Math.round(data.total_release_pp - finished_data[i]));
                }
                return real_data;
            },
            getDaysLabels(total_spring_days) {
                let labels_days = [];
                for (let i = 0; i <= total_spring_days; i++) {
                    labels_days.push("Día " + (i));
                }
                return labels_days;
            },
            drawLabels(t, ctx) {
                let chartInstance = t.chart;
                let datasets = chartInstance.config.data.datasets;
                let index = datasets[0].data.length - 1;
                let difference =  datasets[1].data[index] - datasets[0].data[index];

                ctx.save();
                ctx.font = Chart.helpers.fontString(15, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
                ctx.fillStyle = difference >= 0 ? '#67C23A' : '#F56C6C';
                ctx.backgroundColor = "white"
                ctx.textBaseline = 'bottom';

                let meta = chartInstance.controller.getDatasetMeta(0);
                let len = meta.data.length - 1;
                let xOffset = meta.data[len]._model.x - 3 ;
                let yOffset = meta.data[len]._model.y - 10;
                ctx.fillText(difference.toString(), xOffset, yOffset);

                ctx.restore();
            },
            showBurnDown(elementId, type) {
                let strFilter = "";
                if (type !== "equipo") {
                    strFilter = "?" + type + "=" + elementId;
                }

                return Axios.getInstance().get('api/getReleaseData' + strFilter).then(response => {
                    console.log(response.data);
                    if (response.data.total_release_pp !== 0) {
                        this.showChart = true
                    }
                    let ideal_data = this.getIdealData(response.data);
                    let real_data = this.getRealData(response.data);
                    let days_labels = this.getDaysLabels(response.data.total_release_days);

                    let speedCanvas = document.getElementById(elementId);
                    Chart.defaults.global.defaultFontFamily = "Arial";
                    Chart.defaults.global.defaultFontSize = 14;


                    Chart.defaults.derivedLine = Chart.defaults.line;
                    let that = this;
                    let custom = Chart.controllers.line.extend({
                        draw: function (a) {
                            Chart.controllers.line.prototype.draw.call(this, a);
                            that.drawLabels(this, speedCanvas.getContext("2d"));
                        }
                    });

                    Chart.controllers.derivedLine = custom;

                    let speedData = {
                        labels: days_labels,
                        datasets: [
                            {
                                label: "Puntos codeados",
                                data: real_data,
                                fill: false,
                                borderColor: this.color,
                                backgroundColor: this.color,
                                lineTension: 0,
                            },
                            {
                                label: "Ideal",
                                borderColor: this.color + "88",
                                backgroundColor: this.color + "88",
                                lineTension: 0,
                                borderDash: [5, 5],
                                fill: false,
                                borderWidth: 1,
                                pointRadius: 0,
                                data: ideal_data
                            }
                        ]
                    };

                    let chartOptions = {
                        responsive: true,
                        maintainAspectRatio: false,

                        tooltips: {
                            enabled: true,
                            mode: 'index'
                        },
                        legend: {
                            display: this.legends,
                            position: 'top',
                            labels: {
                                boxWidth: 20,
                                fontColor: 'black'
                            }
                        },
                        scales: {
                            yAxes: [{
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    min: 0,
                                    stepSize: Math.round(response.data.total_release_pp / 2),
                                    max: response.data.total_release_pp
                                }
                            }],
                            xAxes: [{
                                gridLines: {
                                    display: false
                                },
                                ticks: {
                                    callback: function (dataLabel, index) {
                                        // Hide the label of every 2nd dataset. return null to hide the grid line too
                                        if (index === 0 || index === days_labels.length - 1) {
                                            return dataLabel;
                                        }
                                        let factor = this.width < 51 ? 2 : 3
                                        return index % factor === 0 ? dataLabel : '';
                                    }
                                }
                            }]
                        }
                    };

                    let lineChart = new Chart(speedCanvas, {
                        type: 'derivedLine',
                        data: speedData,
                        options: chartOptions
                    });

                    return true;

                });

            }


        }
    }
</script>

<style lang="css">
    .loader {
        border: 8px solid #f3f3f3; /* Light grey */
        border-top: 8px solid #3498db; /* Blue */
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 2s linear infinite;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

</style>
